// 组件
import { ProModal, ProMessage } from '../../antd';
// 常量
import { PrintParams, PrintProps, PrintSet, PrintConfig } from '../interface';
import { WEb_SOCKET_URL } from '../../constants/constant';

const initPrintSet: PrintSet = {
  MarginsTop: 0,
  MarginsBottom: 0,
  MarginsLeft: 0,
  MarginsRight: 0,
  OffsetX: 0,
  OffsetY: 0,
};

const initPrintConfig: PrintConfig = {
  repeatNumber: 1,
};

const initParams: PrintParams = {
  moduleId: '000000',
  templateId: 'DetailParameters',
  printType: 'PDF',
};

export default function printFun(params: PrintParams) {
  // 检测WebSocket是否已经正常启动
  if (!window._socket || window._socket?.readyState !== 1) {
    window._socket = new WebSocket(WEb_SOCKET_URL);
  }
  // 参数合并
  const socketParams: PrintProps = {
    action: 'SENDFOR_PRINT',
    params: {
      ...params,
      ...initParams,
      printSet: {
        ...initPrintSet,
        ...params.printSet,
      },
      printConfig: {
        ...initPrintConfig,
        ...params.printConfig,
      },
    },
  };
  // 打印
  if (window._socket.readyState === 1) {
    window._socket.send(JSON.stringify(socketParams));
  }
  window._socket.onopen = () => {
    window._socket.send(JSON.stringify(socketParams));
  };
  // 启动失败
  window._socket.onerror = () => {
    ProModal.confirm({
      content: '本地打印服务未开启，是否使用浏览器打印功能',
      onOk: () => {
        printPdf(params.remoteDataUrl);
      },
      onCancel: () => {},
    });
  };
  window.onbeforeunload = () => {
    window._socket.close();
  };
}

const PrintIframeId = 'print-iframe-id';

export function printPdf(url?: string) {
  if (!url) {
    return ProMessage.error('远程文件路径未传!');
  }
  if (!window.print) {
    return ProMessage.warning('浏览器版本太低，请使用chrome、firefox浏览器!');
  }
  fetch(url).then(async res => {
    const blob = await res.blob();
    const fileName = url.split('/')[url.split('/').length - 1];
    printFile(blob, fileName);
  });
}

export function printFile(
  blob: Blob,
  fileName = `${new Date().getTime()}.pdf`,
) {
  document.getElementById(PrintIframeId)?.remove?.();
  const iframe = document.createElement('iframe');
  const file = new File([blob], fileName, { type: blob.type });
  iframe.src = window.URL.createObjectURL(file);
  iframe.id = PrintIframeId;
  iframe.setAttribute(
    'style',
    'position:absolute;width:0px;height:0px;left:-500px;top:-500px;',
  );
  document.body.appendChild(iframe);
  iframe.onload = function(e) {
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();
  };
}
